// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LK4c","right":"styles_right__3pCWi"};